import { APP_BASE_PATH } from "../../app/basePath";

const HANDOFF_KEY = "agent-judge:qae-collection";
const RETURN_KEY = "agent-judge:qae-collection-return";
const MAX_AGE = 15 * 60 * 1000;
export type CollectionHandoff = {
  ticket: string;
  source_origin: string;
  exchange_id: string;
  project_id: string;
  received_at: number;
  receipt?: {
    question_path: string;
    question_id: string;
    suite_id: string;
    project_id: string;
  };
};

function collectionProject(path: string): string | null {
  const match = path.match(
    new RegExp(`^${APP_BASE_PATH}/projects/([^/]+)/content/qae-collection$`),
  );
  try {
    return match ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
}

export function captureCollectionHandoff(): void {
  const projectId = collectionProject(location.pathname);
  const fragment = new URLSearchParams(location.hash.slice(1));
  const ticket = fragment.get("qae_ticket");
  if (projectId && ticket) {
    history.replaceState(
      history.state,
      "",
      location.pathname + location.search,
    );
    const source = fragment.get("qae_source") || "";
    try {
      const origin = new URL(source);
      if (
        !/^[A-Za-z0-9_-]{43,128}$/.test(ticket) ||
        origin.origin !== source ||
        (origin.protocol !== "https:" &&
          !(
            origin.protocol === "http:" &&
            ["127.0.0.1", "localhost", "[::1]"].includes(origin.hostname)
          ))
      )
        return;
      const handoff: CollectionHandoff = {
        ticket,
        source_origin: source,
        project_id: projectId,
        exchange_id: crypto.randomUUID(),
        received_at: Date.now(),
      };
      sessionStorage.setItem(HANDOFF_KEY, JSON.stringify(handoff));
      sessionStorage.setItem(
        RETURN_KEY,
        JSON.stringify({ path: location.pathname, received_at: Date.now() }),
      );
    } catch {
      return;
    }
  }
  try {
    const pending = JSON.parse(sessionStorage.getItem(RETURN_KEY) || "null");
    if (
      pending &&
      typeof pending.path === "string" &&
      collectionProject(pending.path) &&
      Date.now() - pending.received_at < MAX_AGE &&
      Date.now() >= pending.received_at &&
      pending.path !== location.pathname
    )
      history.replaceState(history.state, "", pending.path);
  } catch {
    sessionStorage.removeItem(RETURN_KEY);
  }
}

export function readCollectionHandoff(
  projectId: string,
): CollectionHandoff | null {
  try {
    const handoff = JSON.parse(
      sessionStorage.getItem(HANDOFF_KEY) || "null",
    ) as CollectionHandoff | null;
    if (
      !handoff ||
      handoff.project_id !== projectId ||
      !/^[A-Za-z0-9_-]{43,128}$/.test(handoff.ticket) ||
      typeof handoff.received_at !== "number" ||
      Date.now() - handoff.received_at >= MAX_AGE ||
      Date.now() < handoff.received_at
    )
      return null;
    return handoff;
  } catch {
    return null;
  }
}

export function collectionPageEntered(): void {
  sessionStorage.removeItem(RETURN_KEY);
}
export function saveCollectionReceipt(
  handoff: CollectionHandoff,
  receipt: NonNullable<CollectionHandoff["receipt"]>,
): void {
  try {
    sessionStorage.setItem(
      HANDOFF_KEY,
      JSON.stringify({ ...handoff, receipt }),
    );
  } catch {
    /* The server save already succeeded. */
  }
}
